import { render, staticRenderFns } from "./SchoolAdminList.vue?vue&type=template&id=71e217c6&scoped=true"
import script from "./SchoolAdminList.vue?vue&type=script&lang=js"
export * from "./SchoolAdminList.vue?vue&type=script&lang=js"
import style0 from "./SchoolAdminList.vue?vue&type=style&index=0&id=71e217c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e217c6",
  null
  
)

export default component.exports